import { useActiveTimer } from '@/data/hooks';
import { MODE_LABEL, elapsedSec, remainingSec } from '@/timer/engine';
import { useNow } from '@/timer/useNow';
import { formatClock } from '@/lib/time';
import { useCallback } from 'react';

/** Top-bar pill while a run is live on any tab (decision D7): "● Focusing 17:42", or "Paused" when paused. */
export function StatusPill() {
  const timer = useActiveTimer();
  const live = timer.status !== 'idle';
  const derive = useCallback((n: Date) => Math.floor(remainingSec(timer, n) ?? elapsedSec(timer, n)), [timer]);
  const now = useNow(timer.status === 'running', derive);
  if (!live) return null;
  const clock = formatClock(remainingSec(timer, now) ?? elapsedSec(timer, now));
  const running = timer.status === 'running';
  return (
    <span className="inline-flex items-center gap-2 h-[30px] px-3 rounded-pill bg-pill-bg text-pill-fg text-[12px] font-bold whitespace-nowrap" aria-live="off">
      <span className={running ? 'text-accent' : 'text-ink-3'} aria-hidden="true">●</span>
      <span className="hidden sm:inline">{running ? (timer.mode === 'track' ? 'Tracking' : MODE_LABEL[timer.mode]) : 'Paused'}</span>
      <span className="font-mono tabular-nums text-ink">{clock}</span>
    </span>
  );
}
